import React from 'react';
import styled from 'styled-components';

import { MainLayout } from '../common/containers/MainLayout/MainLayout';
import { Card } from '@mui/material';

import { NextPage } from 'next';
import { minWidth } from '../common/styles/helpers';

import { WelcomeBanner } from './dashboard/components/WelcomeBanner';
import { MyIdeasCard } from './dashboard/components/MyIdeasCard';
import { AiPepaCard } from './dashboard/components/AiPepaCard';
import { EmailVerificationInfo } from '../common/components/auth/EmailVerificationInfo';

import { t } from '@lingui/macro';
import { DashboardBanner } from './dashboard/components/DashboardBanner';

const Dashboard: NextPage = () => {
  return (
    <MainLayout protectedRoute title={t`Dashboard`}>
      <DashboardWrapper>
        <EmailVerificationInfo className="span-two" />
        <WelcomeBanner className="span-two" />
        <Card>
          <MyIdeasCard />
        </Card>
        <Card>
          <AiPepaCard />
        </Card>
        <DashboardBanner className="span-two" />
      </DashboardWrapper>
    </MainLayout>
  );
};

export default Dashboard;

export const DashboardWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 16px;

  ${minWidth.tablet} {
    grid-template-columns: 1fr 1fr;
    grid-gap: 32px;
    .span-two {
      grid-column: span 2;
    }
  }
`;
